import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { LockIcon } from "@/shared/icons";

type Props = { isOn: boolean; className?: string };

export default function PlayerMenuSettingsSafetyTfaStatus({ isOn, className }: Props) {
  const { t } = useTranslation("playerMenu");

  return (
    <div
      className={clsx(
        "flex items-center gap-2.5 text-14 font-medium leading-3",
        isOn ? "text-[#84FF97]" : "text-accent-solid",
        className,
      )}
    >
      <LockIcon size={16} />
      {t(`playerMenu.${isOn ? "included" : "disabled"}`)}
    </div>
  );
}
